import * as React from 'react';
import { Grid, Nav, Navbar, NavItem } from 'react-bootstrap';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import { Link } from 'react-router-dom';
import withTracker from '../../with_tracker';
import GpsDebugComponent from './gps_debug_component';
import VehicleMappingDebugComponent from './vehicle_mapping_debug_component';

interface IDebugComponentProps extends Partial<RouteComponentProps<{}>> {
}

class DebugComponent extends React.Component<IDebugComponentProps> {
  public render() {
    return (
      <div>
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to={`${process.env.PUBLIC_URL}/debug`}>Debug</Link>
            </Navbar.Brand>
            <Navbar.Toggle/>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/gps`}>
                <NavItem>
                  GPS Tracker
                </NavItem>
              </LinkContainer>
              <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/gpslist`}>
                <NavItem>
                  GPS Tracker (all events)
                </NavItem>
              </LinkContainer>
              <LinkContainer to={`${process.env.PUBLIC_URL}${this.props.match!.url}/vehiclemapping`}>
                <NavItem>
                  Bus to Line Mapping
                </NavItem>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Grid>
          <Switch>
            <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/gps`}
                   component={withTracker(GpsDebugComponent, {props: {cleanedUp: true}})}/>
            <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/gpslist`}
                   component={withTracker(GpsDebugComponent, {props: {cleanedUp: false}})}/>
            <Route path={`${process.env.PUBLIC_URL}${this.props.match!.url}/vehiclemapping`}
                   component={withTracker(VehicleMappingDebugComponent)}/>
            <Redirect to={`${process.env.PUBLIC_URL}${this.props.match!.url}/gps`}/>
          </Switch>
        </Grid>
      </div>
    );
  }
}

export default DebugComponent;



// WEBPACK FOOTER //
// ./src/components/debug/debug_component.tsx